<script lang="ts" setup>
import { watch } from 'vue';
import api from '@/api';
import { DgrDialog } from '@stockmarkteam/donguri-ui';
import { useSnackbar } from '@/components/common/snackbar/use-snackbar';
import { OrganizationTag } from '@/types';

const props = withDefaults(
  defineProps<{
    organizationTag?: OrganizationTag;
    organizationTags?: OrganizationTag[];
  }>(),
  {
    organizationTags: () => [],
  },
);

const emit = defineEmits(['onClose', 'onSubmit']);

// このコンポーネントはDgrDialogをラップしているだけなので、openの値をこのコンポーネント内で変更しない。
const open = defineModel<boolean>('open', { default: false });

watch(
  () => open.value,
  () => {
    if (!open.value) {
      emit('onClose');
    }
  },
);

const { createSnackbar } = useSnackbar();

const onSubmit = async () => {
  try {
    if (!props.organizationTag) {
      throw new Error('organizationTag is undefined');
    }
    const orgId = props.organizationTag.id;
    const orgOrder = props.organizationTag.order;
    const shouldUpdateOrderOrganizationTagParams =
      props.organizationTags.flatMap(tag =>
        tag.order > orgOrder
          ? [
              {
                id: tag.id,
                order: tag.order - 1,
              },
            ]
          : [],
      );
    await api.bulkOperateOrganizationTags({
      deleteTagIds: [orgId],
      updateTags: shouldUpdateOrderOrganizationTagParams,
    });
    emit('onSubmit');
    createSnackbar({
      message: '組織タグを削除しました',
      type: 'success',
    });
  } catch {
    createSnackbar({
      message: '組織タグの削除に失敗しました',
      type: 'error',
    });
  }
  close();
};
</script>

<template>
  <DgrDialog v-model:open="open" title="組織タグの削除">
    <template #description>
      <div class="modal-content c-text-regular--m">
        <p>{{ organizationTag?.name }}</p>
        <p>を削除しますか？</p>
      </div>
    </template>

    <template #submit>
      <button
        type="button"
        class="o-create-button c-btn c-btn--auto c-btn--negative"
        @click="onSubmit()"
        data-testid="submit-button"
      >
        削除
      </button>
    </template>
  </DgrDialog>
</template>
<style lang="scss" scoped>
.modal-content {
  width: 448px;
}
</style>
